<template>
    <div
        id="story-filter--main"
        class="story-filter--main"
    >
        <div
            id="story-filter__inputs-container"
            class="story-filter__controls story-filter__inner"
            v-if="includeFilter"
        >
            <div class="story-filter__category">
                <div class="story-filter__category--select">
                    <label
                        class="story-filter__category--select-label"
                        for="stories__filter--select"
                    >
                        <span class="access-hidden">Category Filter</span>
                        <select
                            id="stories__filter--select"
                            v-model="category"
                            name="category"
                            class="story-filter__category--input"
                        >
                            <option
                                value=""
                                v-text="'All Categories'"
                            />
                            <option
                                v-for="(cat, index) in categories"
                                :key="index"
                                :value="cat"
                                v-text="cat"
                            />
                        </select>
                    </label>
                </div>
            </div>
        </div>
        <section class="story-filter__stories--container">
            <ul class="story-filter__stories">
                <li
                    v-for="(story, index) in renderedStories"
                    :key="index"
                    class="card-container story-filter__story"
                    @update="update"
                >
                    <a class="card__cards-wrapper" :href="story.cta.link">
                        <div class="card__wrapper ">
                            <div class="card__image--large">
                                <img
                                    :src="story.image.src"
                                    class="card__image"
                                    alt=""
                                >
                            </div>
                            <div class="card__body">
                                <div class="campaign-lockup">
                                    <p
                                        class="campaign-lockup__heading card__link"
                                        v-text="story.heading.copy"
                                    />
                                    <p
                                        class="campaign-lockup__body"
                                        v-text="story.body.copy"
                                    />
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
            <button
                id="more-stories"
                class="cta__standard cta__btn btn btn-blue"
                @click="displayStories()"
            >
                <span class="cta__copy">Load More Stories</span>
            </button>
        </section>
    </div>
</template>

<script>
export default {
    name: 'StoryFilter',
    data() {
        return {
            handle: undefined,
            search: '',
            category: '',
            categories: '',
            stories: [],
            pages: 0,
            storyPages: [],
            renderedStories: [],
            storiesTop: 0,
            storiesBottom: 0,
            scrollTop: 0,
            scrollBottom: 0,
            includeFilter: true
        };
    },
    props: {
        cascadeCategories: {
            type: String,
            required: true,
        },
        cascadeStories: {
            type: String,
            required: true,
        },
        showFilter: {
            type: String,
            required: false, 
            default: "true"
        }
    },
    computed: {
        query() {
            this.pages = 0;
            return `?category=${this.category}`;
        },
    },
    watch: {
        query() {
            if (this.handle) {
                clearTimeout(this.handle);
            }

            this.handle = setTimeout(this.update, 500);
        },
    },
    mounted() {
        this.fetchCategories();
        
        this.fetchStories();

        if(this.showFilter === "false"){
            this.includeFilter = false;
        } else {
            this.includeFilter = true;
        }
        

        const vueThis = this;

        window.addEventListener('resize', () => {
            setTimeout(() => {
                vueThis.update();
            }, 1000);
        });
    },
    methods: {
        update() {
            const showStories = [];
            if(this.pages > 0){
                this.pages = this.pages -1;
            }
            this.stories.forEach((story) => {
                if (story.categories.includes(this.category)) {
                    showStories.push(story);
                } else if (this.category === '') {
                    showStories.push(story);
                }
            });

            this.createPages(showStories);
        },

        fetchCategories() {
            this.categories = JSON.parse(this.cascadeCategories);
        },

        fetchStories() {
            this.handle = undefined;
            this.stories = JSON.parse(this.cascadeStories.replaceAll("\\\'", "'"));
            this.createPages(this.stories);
        },

        displayStories() {
            this.pages += 1;

            // Get document, or throw exception on error

            if (this.pages === this.storyPages.length) {
                document.getElementById('more-stories').classList.add('all-shown');
            } else if (this.pages > this.storyPages.length) {
                return;
            } else {
                document.getElementById('more-stories').classList.remove('all-shown');
            }
            let k; let l;
            this.renderedStories = [];
            for (k = 0, l = this.pages; k < l; k += 1) {
                this.storyPages[k].forEach((story) => {
                    this.renderedStories.push(story);
                });
            }
        },

        createPages(storiesList) {
            let i; let j; let temparray; let chunk;
            this.storyPages = [];

            if (window.innerWidth < 764) {
                chunk = 3;
            } else {
                chunk = 6;
            }

            for (i = 0, j = storiesList.length; i < j; i += chunk) {
                temparray = storiesList.slice(i, i + chunk);

                this.storyPages.push(temparray);
            }

            this.displayStories();
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Campaign/CampaignStoriesFilter.vue